import React from 'react';
import { Outlet } from 'react-router-dom';
import ModeIndicator from '../components/ModeIndicator/ModeIndicator';
import './App.css';

const App: React.FC = () => {
  return (
    <div className="app">
      <ModeIndicator />
      <Outlet />
    </div>
  );
};

export default App;
